import axios from "axios";
import { serviceKeys } from "../../constants";

export const getStoreEvents = async (limit = 10, offset = 0) => {
  const response = await axios.get(
    `${serviceKeys.BASE_URL}api/v1/storefront/events/?limit=${limit}&offset=${offset}`,
  );
  return response.data;
};

export const getStoreEventsById = async (id) => {
  const response = await axios.get(
    `${serviceKeys.BASE_URL}api/v1/storefront/events/${id}`,
  );
  return response.data;
};

export const getResidencyBySlug = async (slug) => {
  const res = await axios.get(
    `${serviceKeys.BASE_URL}api/v1/residency/${slug}/`,
  );
  return res.data;
};